<template>
</template>

<script>
    export default {
        props: ['type', 'message'],

        mounted() {
            this.$buefy.toast.open({
                message: this.message,
                type: 'is-' + this.type
            });
        }
    }
</script>